(() => {
  const initializeNumberHatBuilder = (builder) => {
    if (!builder || builder.dataset.initialized === 'true') {
      return;
    }

    builder.dataset.initialized = 'true';

    const numberInput = builder.querySelector('.number-hat-number');
    const numberColorSelect = builder.querySelector(
      '.number-hat-number-color'
    );
    const borderColorSelect = builder.querySelector(
      '.number-hat-border-color'
    );
    const summaryList = builder.querySelector(
      '.number-hat-summary-list'
    );
    const card = builder.querySelector('.number-hat-card');
    const validationMessage = builder.querySelector(
      '.number-hat-validation-message'
    );

    const productForm =
      builder.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (
      !numberInput ||
      !numberColorSelect ||
      !borderColorSelect ||
      !summaryList
    ) {
      return;
    }

    const cleanNumber = () => {
      numberInput.value = numberInput.value
        .replace(/\D/g, '')
        .slice(0, 3);
    };

    const updateSummary = () => {
      const number = numberInput.value.trim();
      const numberColor = numberColorSelect.value;
      const borderColor = borderColorSelect.value;

      const summaryItems = [];

      if (number) {
        summaryItems.push(`<li><strong>Number:</strong> ${number}</li>`);
      }

      if (numberColor) {
        summaryItems.push(
          `<li><strong>Number Color:</strong> ${numberColor}</li>`
        );
      }

      if (borderColor) {
        summaryItems.push(
          `<li><strong>Border Color:</strong> ${borderColor}</li>`
        );
      }

      summaryList.innerHTML = summaryItems.length
        ? summaryItems.join('')
        : '<li>Enter your number and select your colors.</li>';
    };

    const clearValidationError = () => {
      const isComplete =
        numberInput.value.trim() &&
        numberColorSelect.value &&
        borderColorSelect.value;

      if (!isComplete) {
        return;
      }

      card?.classList.remove('number-hat-card--error');

      if (validationMessage) {
        validationMessage.hidden = true;
      }
    };

    const validateBuilder = () => {
      cleanNumber();

      const number = numberInput.value.trim();
      const numberColor = numberColorSelect.value;
      const borderColor = borderColorSelect.value;

      const numberIsValid = /^[0-9]{1,3}$/.test(number);
      const isValid =
        numberIsValid &&
        Boolean(numberColor) &&
        Boolean(borderColor);

      card?.classList.toggle(
        'number-hat-card--error',
        !isValid
      );

      if (validationMessage) {
        validationMessage.hidden = isValid;
      }

      if (!isValid) {
        const panel = builder.querySelector(
          '.embroidery-locations-panel'
        );

        if (panel) {
          panel.open = true;
        }

        if (!numberIsValid) {
          numberInput.focus();
        } else if (!numberColor) {
          numberColorSelect.focus();
        } else {
          borderColorSelect.focus();
        }
      }

      return isValid;
    };

    numberInput.addEventListener('input', () => {
      cleanNumber();
      updateSummary();
      clearValidationError();
    });

    numberColorSelect.addEventListener('change', () => {
      updateSummary();
      clearValidationError();
    });

    borderColorSelect.addEventListener('change', () => {
      updateSummary();
      clearValidationError();
    });

    if (productForm) {
      productForm.addEventListener(
        'submit',
        (event) => {
          if (!validateBuilder()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true
      );
    }

    updateSummary();
  };

  const initializeAllNumberHatBuilders = () => {
    document
      .querySelectorAll('[data-number-hat-builder]')
      .forEach(initializeNumberHatBuilder);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllNumberHatBuilders
    );
  } else {
    initializeAllNumberHatBuilders();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeAllNumberHatBuilders
  );
})();